/**
 * 入力の決まり（Issue #668）。replay ごとにサーバーが持ち、両席・Web・iPad・リアル再現の全部に効く（server/synchro_server/ocg/input_policy.py）。
 *   登録: 未確認のカードが 1 枚でもあれば登録だけ（all・既定）/ 最後の応答より後ろの未確認で止める（after_answer）/ 止めない（off）
 *   チェーン確認: 強制でないものは通す（chains・既定）/ 発動できるカードが無いときだけ（empty）/ 通さない（off）
 *   続けて通す: 人が答えたあとのチェーン確認をサービスが続けて「チェーンしない」で通す。止まる場面（相手のチェーン・攻撃宣言・裏側を対象に）
 * 変えたら onChange(一部の決まり) をページへ（ページが OcgSetInputPolicy を送って状態を取り直す）。席ごとの止まる場面の上書きは API（seats）で
 *
 * このデュエル（Issue #809）: 実物のカードを再現（今まで）/ ランダムで遊ぶ（ドローも乱数も core が決める。登録は無い。先攻はじゃんけん）。
 * 混ぜるかどうかで初手から変わるので、切り替えられるのは開始前（応答も登録も無いとき・ルームが開いていないとき）だけ（randomPlayLocked）。
 * 変えたら onRandomPlay(true | false) をページへ（ページが OcgUpdateReplay の random_play を送る）
 */
import { useState } from 'react';
import { btn } from './RespondTab';

const REGISTER = [['all', '未確認があれば登録だけ'], ['after_answer', '最後の応答のあとの未確認で止める'], ['off', '止めない']];
const SKIP = [['chains', '強制でないものは通す'], ['empty', '発動できるカードが無いときだけ'], ['off', '通さない']];
const STOPS = [['stop_on_opponent_chain', '相手のチェーンで止まる'], ['stop_on_attack', '攻撃宣言で止まる'], ['stop_on_facedown_target', '裏側を対象にされたら止まる']];

const PLAY = [[false, '実物のカードを再現'], [true, 'ランダムで遊ぶ']];

export default function InputPolicyPanel({ policy = null, busy = false, onChange, randomPlay = false, randomPlayLocked = true, onRandomPlay }) {
  const [open, setOpen] = useState(false);
  if (!policy) return null;
  const chip = (on) => ({ ...btn(on ? 'primary' : 'plain'), minHeight: 32, padding: '4px 10px', fontSize: 12 });
  const row = (label, items, value, key) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <div style={{ fontSize: 12, opacity: 0.8 }}>{label}</div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {items.map(([v, text]) => (
          <button key={v} type="button" data-testid={`policy-${key}-${v}`} aria-pressed={value === v} disabled={busy || value === v} style={chip(value === v)}
            onClick={() => onChange?.({ [key]: v })}>{text}</button>
        ))}
      </div>
    </div>
  );
  const skip = policy.auto_skip ?? {};
  return (
    <div data-testid="input-policy" style={{ marginBottom: 10, border: '1px solid #2a3552', borderRadius: 8, padding: 8 }}>
      <button type="button" data-testid="input-policy-toggle" onClick={() => setOpen((v) => !v)}
        style={{ background: 'none', border: 'none', color: '#e8eefc', fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: 0 }}>
        {open ? '▾' : '▸'} 入力の決まり（両席に効く）
      </button>
      {open ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div style={{ fontSize: 12, opacity: 0.8 }}>このデュエル{randomPlayLocked ? '（開始前だけ変えられる）' : ''}</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {PLAY.map(([v, text]) => (
                <button key={String(v)} type="button" data-testid={`policy-random-play-${v ? 'on' : 'off'}`} aria-pressed={!!randomPlay === v}
                  disabled={busy || randomPlayLocked || !!randomPlay === v || !onRandomPlay} style={chip(!!randomPlay === v)}
                  onClick={() => onRandomPlay?.(v)}>{text}</button>
              ))}
            </div>
          </div>
          {randomPlay ? null : row('未確認のカード', REGISTER, policy.register_mode, 'register_mode')}
          {row('画面に来たチェーン確認', SKIP, policy.skip_mode, 'skip_mode')}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div style={{ fontSize: 12, opacity: 0.8 }}>答えたあとのチェーン確認</div>
            <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center' }}>
              <input type="checkbox" data-testid="policy-auto-skip" checked={!!skip.enabled} disabled={busy}
                onChange={(e) => onChange?.({ auto_skip: { enabled: e.target.checked } })} />続けて「チェーンしない」で通す
            </label>
            {skip.enabled ? STOPS.map(([k, text]) => (
              <label key={k} style={{ fontSize: 12, display: 'flex', gap: 6, alignItems: 'center', paddingLeft: 18 }}>
                <input type="checkbox" data-testid={`policy-${k}`} checked={!!skip[k]} disabled={busy}
                  onChange={(e) => onChange?.({ auto_skip: { [k]: e.target.checked } })} />{text}
              </label>
            )) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}
